import "./accessibility_footer.scss";

import { useTranslation } from "react-i18next";
import { typedMemo } from "src/types";

export const AccessibilityFooter = typedMemo(() => {
  const { t } = useTranslation();

  const downloadAccessibilityFile = () => {
    const link = document.createElement("a");
    link.href =
      "/assets/files/Accessibility Statement - cai-digitale.gruppoitas.it.pdf";
    link.download = "Accessibility Statement - cai-digitale.gruppoitas.it.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <footer className="footer">
      <div className="container d-flex flex-column align-items-start gap-2">
        <a
          className="footer--link label-l--600"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            downloadAccessibilityFile();
          }}
        >
          {t("accessibility_footer.title")}
        </a>
        <div className="footer--info label-m">
          {t("accessibility_footer.description")}
        </div>
      </div>
    </footer>
  );
});
